import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

interface AleaVollIconProps extends IconProps {
  color?: string;
}

export const AleaVollIcon: React.FC<AleaVollIconProps> = ({ 
  color = '#2B4956', 
  ...props 
}) => {
  return (
    <Icon
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path 
        d="M36.4945 29.5674C36.4945 35.6574 31.5445 40.5874 25.4445 40.5874C19.3445 40.5874 14.3945 35.6474 14.3945 29.5674C14.3945 23.4874 25.4445 9.60742 25.4445 9.60742C25.4445 9.60742 36.4945 23.4774 36.4945 29.5674Z" 
        fill="#EF5B35" 
        stroke={color} 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default AleaVollIcon; 